import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff438778")

_pushScopeId("data-v-ff438778")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", { class: "header-margin" }, "Account Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" General ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Security ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" User Preferences ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_aside = _resolveComponent("el-aside")
  const _component_ProfileGeneralTab = _resolveComponent("ProfileGeneralTab")
  const _component_ProfileSecurityTab = _resolveComponent("ProfileSecurityTab")
  const _component_ProfilePreferencesTab = _resolveComponent("ProfilePreferencesTab")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.account.signin_provider === 'geotab')
      ? (_openBlock(), _createBlock("p", _hoisted_1, "Geotab user data is updated automatically. Changes to user data should be made on the Geotab portal. "))
      : _createCommentVNode("", true),
    _createVNode(_component_el_container, { direction: "horizontal" }, {
      default: _withId(() => [
        _createVNode(_component_el_aside, {
          width: "200px",
          class: "menu-aside"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_container, { direction: "vertical" }, {
              default: _withId(() => [
                _hoisted_2,
                _createVNode(_component_el_button, {
                  onClick: _ctx.routeToGeneral,
                  class: "margin-none"
                }, {
                  default: _withId(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: _ctx.routeToSecurity,
                  class: "margin-none"
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  onClick: _ctx.routeToPreferences,
                  class: "margin-none"
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.editTab === 'general')
          ? (_openBlock(), _createBlock(_component_ProfileGeneralTab, { key: 0 }))
          : _createCommentVNode("", true),
        (_ctx.editTab === 'security')
          ? (_openBlock(), _createBlock(_component_ProfileSecurityTab, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.editTab === 'preferences')
          ? (_openBlock(), _createBlock(_component_ProfilePreferencesTab, { key: 2 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
})